export enum CustomerType {
  replenishment = 'REPLENISHMENT',
  repEvolution = 'REP_EVOLUTION',
  sterilog = 'STERILOG',
  hybrid = 'HYBRID'
}
